function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_1",
  "data-name": "Grupo 1",
  transform: "translate(-741 -1898)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1",
  "data-name": "Ret\\xE2ngulo 1",
  width: 70,
  height: 70,
  transform: "translate(741 1898)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_193",
  "data-name": "Grupo 193",
  transform: "translate(513.51 1187.23)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_33",
  "data-name": "Ret\\xE2ngulo 33",
  width: 7.859,
  height: 3.756,
  transform: "translate(258.476 738.241)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_73",
  "data-name": "Caminho 73",
  d: "M252.5,728.477s-.452-3.988,4.9-3.929,4.9,3.929,4.9,3.929",
  transform: "translate(4.823)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_74",
  "data-name": "Caminho 74",
  d: "M252.4,753.384h19.646M247.49,741.871V761.91a3.923,3.923,0,0,0,3.929,3.929H273.03a3.922,3.922,0,0,0,3.929-3.929V741.871c0-5.737-.982-15.324-14.735-15.324S247.49,736.134,247.49,741.871Zm24.558,9.646v8.526a1.968,1.968,0,0,1-1.965,1.965H254.366a1.968,1.968,0,0,1-1.965-1.965v-8.526a1.968,1.968,0,0,1,1.965-1.965h15.717a1.968,1.968,0,0,1,1.965,1.966Z",
  transform: "translate(0 1.93)",
  fill: "none",
  stroke: "#000",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_208",
  "data-name": "Caminho 208",
  d: "M13.5,0A13.5,13.5,0,1,1,0,13.5,13.5,13.5,0,0,1,13.5,0Z",
  transform: "translate(781 1906)",
  fill: "#819d42"
}), /*#__PURE__*/React.createElement("path", {
  id: "Icon_feather-check",
  "data-name": "Icon feather-check",
  d: "M18.923,9l-8.885,8.885L6,13.846",
  transform: "translate(783 1906.615)",
  fill: "none",
  stroke: "#fafafa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

function SvgMochilaCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMochilaCheck);
export default __webpack_public_path__ + "static/media/mochila-check.603d2e1a.svg";
export { ForwardRef as ReactComponent };